import React from 'react';
import { useParams } from 'react-router-dom';

const StudentPerformancePage = () => {
  const { studentId } = useParams();
  return (
    <div className="p-6">
      <h2 className="text-2xl mb-4">Performance for Student {studentId}</h2>
      {/* TODO: Add timeline chart and filters here */}
    </div>
  );
};

export default StudentPerformancePage;
